import { useI18n } from '../stores/I18nContext'
import { useProject } from '../stores/ProjectContext'
import { useAI } from '../stores/AIContext'
import './MobileTabBar.css'

/**
 * Bottom tab bar shown only on mobile.
 * Tabs: Canvas (process view) · Description · AI · Menu.
 * The "Menu" tab opens the existing mobile header menu via a custom event
 * (Header.jsx listens for 'teddo:open-mobile-menu').
 */
export default function MobileTabBar() {
  const { t, language } = useI18n()
  const isNo = language === 'nb'
  const { activeView, setActiveView, setSelectedCheckpoint } = useProject()
  const { isOpen: aiOpen, togglePanel: toggleAI, setIsOpen: setAIOpen } = useAI()

  const goCanvas = () => {
    setAIOpen(false)
    setActiveView('process')
  }
  const goDescription = () => {
    setAIOpen(false)
    setSelectedCheckpoint(null)
    setActiveView('description')
  }
  const goAI = () => {
    // Toggle the AI panel; keep whatever view is active behind it.
    toggleAI()
  }
  const openMenu = () => {
    window.dispatchEvent(new CustomEvent('teddo:open-mobile-menu'))
  }

  const canvasActive = !aiOpen && activeView !== 'description'
  const descActive = !aiOpen && activeView === 'description'

  return (
    <nav className="mobile-tab-bar" aria-label={isNo ? 'Hovedmeny' : 'Main navigation'}>
      <button
        type="button"
        className={`mtb-btn ${canvasActive ? 'is-active' : ''}`}
        onClick={goCanvas}
        aria-current={canvasActive ? 'page' : undefined}
        aria-label={isNo ? 'Diagram' : 'Canvas'}
      >
        <span className="mtb-icon" aria-hidden="true">
          {/* canvas / chart icon */}
          <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M3 3v18h18" />
            <path d="M7 15l4-4 3 3 5-7" />
          </svg>
        </span>
        <span className="mtb-label">{isNo ? 'Diagram' : 'Canvas'}</span>
      </button>

      <button
        type="button"
        className={`mtb-btn ${descActive ? 'is-active' : ''}`}
        onClick={goDescription}
        aria-current={descActive ? 'page' : undefined}
        aria-label={isNo ? 'Beskrivelse' : 'Description'}
      >
        <span className="mtb-icon" aria-hidden="true">
          <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M4 4h16v16H4z" />
            <path d="M8 9h8M8 13h8M8 17h5" />
          </svg>
        </span>
        <span className="mtb-label">{isNo ? 'Tekst' : 'Notes'}</span>
      </button>

      <button
        type="button"
        className={`mtb-btn ${aiOpen ? 'is-active' : ''}`}
        onClick={goAI}
        aria-current={aiOpen ? 'page' : undefined}
        aria-label="Teddo AI"
      >
        <span className="mtb-icon mtb-icon-bear" aria-hidden="true">
          <img src="/teddo_the_icon_with_transparent.png" alt="" />
        </span>
        <span className="mtb-label">Teddo</span>
      </button>

      <button
        type="button"
        className="mtb-btn"
        onClick={openMenu}
        aria-label={isNo ? 'Meny' : 'Menu'}
      >
        <span className="mtb-icon" aria-hidden="true">
          <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M4 6h16M4 12h16M4 18h16" />
          </svg>
        </span>
        <span className="mtb-label">{isNo ? 'Meny' : 'Menu'}</span>
      </button>
    </nav>
  )
}
